import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	labelDiscardSuggestions: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-draft-list.discard-suggestions.label-discard-suggestions',
		defaultMessage: 'Discard and close',
		description: 'Discard suggestions button label.',
	},
	labelDiscardModal: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-draft-list.discard-suggestions.label-discard-modal',
		defaultMessage: 'Discard',
		description: 'Discard button label for discard suggestions modal.',
	},
	labelCancelModal: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-draft-list.discard-suggestions.label-cancel-modal',
		defaultMessage: 'Cancel',
		description: 'Cancel button label for discard suggestions modal.',
	},
	warningTitleModal: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-draft-list.discard-suggestions.warning-title-modal',
		defaultMessage: 'Are you sure you want to discard all suggestions?',
		description: 'Warning title for discard suggestions modal. ',
	},
	warningBodyModal: {
		id: 'issue-view-common-views.child-issues-panel.ai-issue-breakdown.issue-breakdown-draft-list.discard-suggestions.warning-body-modal',
		defaultMessage: "You're going to lose all suggestions if you continue.",
		description: 'Warning title for discard suggestions modal.',
	},
});
